import type {
  OpenApiRefType,
  OpenApiTicketCategory,
  OpenApiTicketPriority,
  OpenApiTicketStatus,
  TicketCommentResp,
  TicketResp,
} from '@/models/openapi.ts'

export const TICKET_STATUSES = [
  'OPEN',
  'IN_PROGRESS',
  'WAITING',
  'RESOLVED',
  'CLOSED',
] as const satisfies readonly OpenApiTicketStatus[]
export type TicketStatus = (typeof TICKET_STATUSES)[number]

export const TICKET_PRIORITIES = [
  'LOW',
  'NORMAL',
  'HIGH',
  'MEDIUM',
  'URGENT',
] as const satisfies readonly OpenApiTicketPriority[]
export type TicketPriority = (typeof TICKET_PRIORITIES)[number]

export const TICKET_CATEGORIES = [
  'DEVICE_FAULT',
  'CONNECTIVITY',
  'ALARM_HANDLING',
  'ACCOUNT',
  'OTHER',
  'INCIDENT',
  'REQUEST',
  'PROBLEM',
  'CHANGE',
] as const satisfies readonly OpenApiTicketCategory[]
export type TicketCategory = (typeof TICKET_CATEGORIES)[number]

export const TICKET_REF_TYPES = [
  'SERVICE_USER',
  'AUTHORITY',
  'SCHEME',
  'DEVICE',
  'CONTACT',
  'ORGANIZATION',
] as const satisfies readonly OpenApiRefType[]
export type TicketRefType = (typeof TICKET_REF_TYPES)[number]

/** Derived directly from the OpenAPI schema. */
export type TicketUserSummary = NonNullable<TicketResp['assigneeUser']>
export type TicketAttachment = NonNullable<TicketResp['attachments']>[number]
export type TicketDevice = NonNullable<TicketResp['devices']>[number]

/** Input shape used for ref-based API calls (required fields for path params). */
export type TicketRefSummary = {
  refType: TicketRefType
  refId: string
  name?: string
}

export type Ticket = TicketResp

export type TicketComment = TicketCommentResp

export type TicketActionType =
  | 'CREATED'
  | 'STATUS_CHANGED'
  | 'PRIORITY_CHANGED'
  | 'CATEGORY_CHANGED'
  | 'ASSIGNEE_CHANGED'
  | 'COMMENT_ADDED'
